export const SET_LOCATION = 'SET_LOCATION';
export const SET_MAP_VIEW = 'SET_MAP_VIEW';
export const SET_POSTER_LAYOUT = 'SET_POSTER_LAYOUT';
export const SET_MAP_STYLE = 'SET_MAP_STYLE';
export const SET_POSTER_STYLE = 'SET_POSTER_STYLE';
export const SET_MAP_LABELS = 'SET_MAP_LABELS';
export const SET_MAP_RESOLUTION = 'SET_MAP_RESOLUTION';
export const SET_DEVICE_TYPE = 'SET_DEVICE_TYPE';

export const ADD_CART_ITEM = 'ADD_CART_ITEM';
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
export const EDIT_CART_ITEM = 'EDIT_CART_ITEM';
export const ADD_CART_ITEM_QUANTITY = 'ADD_CART_ITEM_QUANTITY';
export const SET_PROMOTION = 'SET_PROMOTION';

export const POST_ORDER_REQUEST = 'POST_ORDER_REQUEST';
export const POST_ORDER_SUCCESS = 'POST_ORDER_SUCCESS';
export const POST_ORDER_FAILURE = 'POST_ORDER_FAILURE';

export const CHECKOUT_FORM_STATE_CHANGE = 'CHECKOUT_FORM_STATE_CHANGE';



// WEBPACK FOOTER //
// ./src/action-types.js